/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Fintecy Investors API
 * API for managing investors, accounts, and transactions in the Fintecy platform
 * OpenAPI spec version: 1.0.0
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { Asset, Error, MarketData } from '.././model';

import { customInstance } from '../../axios-instance';

/**
 * Fetches latest market data from CBR and ECB
 * @summary Fetch latest market data
 */
export const fetchLatestMarketData = (signal?: AbortSignal) => {
  return customInstance<MarketData>({ url: `/api/integrations/marketData`, method: 'GET', signal });
};

export const getFetchLatestMarketDataQueryKey = () => {
  return [`/api/integrations/marketData`] as const;
};

export const getFetchLatestMarketDataQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchLatestMarketData>>,
  TError = Error,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof fetchLatestMarketData>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFetchLatestMarketDataQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchLatestMarketData>>> = ({ signal }) =>
    fetchLatestMarketData(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchLatestMarketData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchLatestMarketDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchLatestMarketData>>
>;
export type FetchLatestMarketDataQueryError = Error;

export function useFetchLatestMarketData<
  TData = Awaited<ReturnType<typeof fetchLatestMarketData>>,
  TError = Error,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchLatestMarketData>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchLatestMarketData>>,
          TError,
          Awaited<ReturnType<typeof fetchLatestMarketData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFetchLatestMarketData<
  TData = Awaited<ReturnType<typeof fetchLatestMarketData>>,
  TError = Error,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchLatestMarketData>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchLatestMarketData>>,
          TError,
          Awaited<ReturnType<typeof fetchLatestMarketData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFetchLatestMarketData<
  TData = Awaited<ReturnType<typeof fetchLatestMarketData>>,
  TError = Error,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchLatestMarketData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Fetch latest market data
 */

export function useFetchLatestMarketData<
  TData = Awaited<ReturnType<typeof fetchLatestMarketData>>,
  TError = Error,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchLatestMarketData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFetchLatestMarketDataQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a list of all assets
 * @summary Get all assets
 */
export const getAllAssets = (signal?: AbortSignal) => {
  return customInstance<Asset[]>({ url: `/api/assets`, method: 'GET', signal });
};

export const getGetAllAssetsQueryKey = () => {
  return [`/api/assets`] as const;
};

export const getGetAllAssetsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllAssets>>,
  TError = Error,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAssets>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllAssetsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllAssets>>> = ({ signal }) =>
    getAllAssets(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllAssets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllAssets>>>;
export type GetAllAssetsQueryError = Error;

export function useGetAllAssets<TData = Awaited<ReturnType<typeof getAllAssets>>, TError = Error>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAssets>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAssets>>,
          TError,
          Awaited<ReturnType<typeof getAllAssets>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllAssets<TData = Awaited<ReturnType<typeof getAllAssets>>, TError = Error>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAssets>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAssets>>,
          TError,
          Awaited<ReturnType<typeof getAllAssets>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllAssets<TData = Awaited<ReturnType<typeof getAllAssets>>, TError = Error>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAssets>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get all assets
 */

export function useGetAllAssets<TData = Awaited<ReturnType<typeof getAllAssets>>, TError = Error>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllAssets>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAllAssetsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
